<template>
  <div class="form-group" :class="setPlaceholderClasses">
    <datetime
      :disabled="disabled"
      :value="value"
      value-zone="local"
      zone="local"
      class="theme-datepicker"
      :id="id"
      :flow="flow"
      :type="type"
      input-class="form-control"
      @input="$emit('input', $event)"
      ref="input"
      :format="getFormat()"
      :auto="true"
    ></datetime>
    <label :for="id" @click="showPicker">{{ text }}</label>
    <span v-if="clear" class="clear-value" @click="clearValue"
      ><i class="fas fa-times"></i
    ></span>
  </div>
</template>
<script>
import placeholder from "@mixins/placeholder.js";
export default {
  name: "volcan-input-datepicker",
  mixins: [placeholder],
  props: {
    disabled: Boolean,
    text: String,
    type: String,
    flow: {
      // type: Array,
      // default() {
      //   return "";
      //   // return this.type === "date"           ? ["year", "month", "date"]           : ["year", "month", "date", "time"];
      // },
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      id: null,
    };
  },
  watch: {
    value(newValue) {
      this.computedValue = newValue;
    },
  },
  mounted() {
    this.id = "input" + this._uid;
  },
  methods: {
    getFormat() {
      return this.type == "date"
        ? { year: "numeric", month: "long", day: "numeric" }
        : {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
          };
    },
    showPicker() {
      this.$refs.input.$el.children[0].click();
    },
    clearValue() {
      this.$emit("input", null);
      this.$emit("inputChanged", null);
    },
  },
};
</script>
<style lang="scss">
@import "../../../Shared/Layout/Assets/sass/base/_variables.scss";

.theme-datepicker .vdatetime-popup__header,
.theme-datepicker .vdatetime-calendar__month__day--selected > span > span,
.theme-datepicker
  .vdatetime-calendar__month__day--selected:hover
  > span
  > span {
  background: $darkblue;
}

.theme-datepicker .vdatetime-year-picker__item--selected,
.theme-datepicker .vdatetime-time-picker__item--selected {
  color: $darkblue;
}

.theme-datepicker .vdatetime-popup__actions__button {
  color: black;
}

.clear-value {
  position: absolute;
  right: 15px;
  top: 0;
  bottom: 0;
  height: 14px;
  margin: auto;
  font-size: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-datepicker.vue